export default __webpack_public_path__ + "static/media/facebookLogo.5bffa663.svg";